export const messages = {
  en: {
    startWork: {
      state: {
        all: 'All',
        W: 'Pending',
        D: 'Processing',
        C: 'Completed'
      },
      search: {
        title: 'Search Conditions',
        workName: 'Work Order Name',
        staffName: 'Handler',
        startTime: 'Start Time',
        endTime: 'End Time'
      },
      list: {
        title: 'Work Order List',
        draft: 'Draft'
      },
      table: {
        workId: 'ID',
        workName: 'Work Order Name',
        typeName: 'Type Name',
        workCycle: 'Cycle',
        startTime: 'Start Time',
        endTime: 'End Time',
        createUser: 'Creator',
        handler: 'Handler',
        ccUser: 'CC User',
        state: 'Status',
        createTime: 'Create Time'
      },
      cycle: {
        once: 'One-time',
        periodic: 'Periodic'
      },
      operation: {
        stop: 'Stop',
        start: 'Start'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this work order?',
        success: 'Delete successfully',
        error: 'Delete failed'
      }
    },
  },
  zh: {
    startWork: {
      state: {
        all: '全部',
        W: '待处理',
        D: '处理中',
        C: '处理完成'
      },
      search: {
        title: '查询条件',
        workName: '工单名称',
        staffName: '处理人',
        startTime: '开始时间',
        endTime: '结束时间'
      },
      list: {
        title: '发起工作单',
        draft: '起草'
      },
      table: {
        workId: '编号',
        workName: '工单名称',
        typeName: '类型名称',
        workCycle: '标识',
        startTime: '开始时间',
        endTime: '结束时间',
        createUser: '发起人',
        handler: '处理人',
        ccUser: '抄送人',
        state: '状态',
        createTime: '创建时间'
      },
      cycle: {
        once: '一次性工单',
        periodic: '周期性工单'
      },
      operation: {
        stop: '停止',
        start: '启用'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除工作单',
        success: '删除成功',
error: '删除失败'
    }
  },
  'zh-TW': {
    startWork: {
      state: {
        all: '全部',
        W: '待處理',
        D: '處理中',
        C: '處理完成'
      },
      search: {
        title: '查詢條件',
        workName: '工單名稱',
        staffName: '處理人',
        startTime: '開始時間',
        endTime: '結束時間'
      },
      list: {
        title: '發起工作單',
        draft: '起草'
      },
      table: {
        workId: '編號',
        workName: '工單名稱',
        typeName: '類型名稱',
        workCycle: '標識',
        startTime: '開始時間',
        endTime: '結束時間',
        createUser: '發起人',
        handler: '處理人',
        ccUser: '抄送人',
        state: '狀態',
        createTime: '創建時間'
      },
      cycle: {
        once: '一次性工單',
        periodic: '周期性工單'
      },
      operation: {
        stop: '停止',
        start: '啟用'
      },
      delete: {
        title: '請確認您的操作',
        confirm: '確定刪除工單',
        success: '刪除成功',
        error: '刪除失敗'
      }
    }
  }
}
}